export const Types = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT'
  }